'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.unconnectedWithConfig = unconnectedWithConfig;

exports.default = function (WrappedComponent) {
  return (0, _reactRedux.connect)(mapStateToProps)(unconnectedWithConfig(WrappedComponent));
};

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactHyperscript = require('react-hyperscript');

var _reactHyperscript2 = _interopRequireDefault(_reactHyperscript);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _state$mason = state.mason,
      apiKey = _state$mason.apiKey,
      blacklistedIds = _state$mason.blacklistedIds,
      components = _state$mason.components,
      didInit = _state$mason.didInit,
      error = _state$mason.error,
      isLoadingStylesheets = _state$mason.isLoadingStylesheets,
      projects = _state$mason.projects;
  var missingComponentId = didInit && !_lodash2.default.has(components, ownProps.id);

  if (missingComponentId) {
    return {
      apiKey: apiKey,
      blacklistedIds: blacklistedIds,
      error: error,
      isLoadingStylesheets: isLoadingStylesheets,
      missingComponentId: missingComponentId
    };
  }

  var component = _lodash2.default.get(components, ownProps.id);

  var project = ownProps.project || _lodash2.default.get(projects, _lodash2.default.get(component, 'projectId'));

  var datasources = ownProps.datasources || _lodash2.default.get(project, 'datasources', {});

  var config = function () {
    if (_lodash2.default.has(ownProps, 'config')) {
      return ownProps.config;
    }

    return _lodash2.default.get(component, 'config', null);
  }();

  return {
    apiKey: apiKey,
    blacklistedIds: blacklistedIds,
    config: config,
    datasources: datasources,
    error: error,
    isLoadingStylesheets: isLoadingStylesheets,
    missingComponentId: missingComponentId,
    project: project
  };
};

function unconnectedWithConfig(WrappedComponent) {
  var getConfig = function getConfig(props) {
    if (!_lodash2.default.has(props, 'config')) {
      return null;
    }

    if (_lodash2.default.isString(props.config)) {
      return JSON.parse(props.config);
    }

    return props.config;
  };

  return function (props) {
    try {
      var blacklistedIds = props.blacklistedIds,
          isLoadingStylesheets = props.isLoadingStylesheets,
          missingComponentId = props.missingComponentId,
          error = props.error,
          id = props.id;

      if (_lodash2.default.indexOf(blacklistedIds, id) > -1) {
        throw new Error('Component with ID "' + id + '" does not have domain "' + window.location.hostname + '" whitelisted in Settings.');
      }

      if (missingComponentId && _lodash2.default.isEmpty(props.config)) {
        throw new Error('Component with ID "' + id + '" cannot be found. Perhaps it needs to be added in the componentIds prop in the Mason constructor.');
      }

      if (error) {
        throw new Error(error);
      } // Wait for stylesheets to be loaded


      if (isLoadingStylesheets) {
        return (0, _reactHyperscript2.default)('');
      }

      var config = getConfig(props);
      return (0, _reactHyperscript2.default)(WrappedComponent, _extends({}, props, {
        config: config
      }));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('' + error.message);
      return (0, _reactHyperscript2.default)('');
    }
  };
}